import React, { Component } from 'react';

class FontAwesome extends Component {
  render() {
    let type;
    switch (this.props.type) {
      case 'solid':
      case 'thick': type = 'fas';
                    break;
      case 'light':
      case 'lite':
      case  'thin': type = 'fal';
                    break;
      default:
        type = 'far';
    }

  	return (
      <span id={this.props.id} className={`${type} fa-${this.props.name} ${this.props.className}`.trim()}></span>
    );
  }
}

export default FontAwesome;



// WEBPACK FOOTER //
// ./src/components/FontAwesome.js